<div>
  <h1 class="title">Votre adresse</h1>
  <h5 class="title-text-muted text-muted fs-16">
    Cela nous permettra de vous présenter des opportunités de travail à
    proximité de chez vous.
  </h5>
  <div [formGroup]="form">
    <div class="border border--1 rounded my-2">
      <div class="px-4 py-2">
        <div class="my-3 w-100">
          <!-- <app-custom-input [label]="'Adresse du site'" [parentGroupName]="'{{$index}}'" [parentForm]="thirdStepFormControl"  type="autocomplete" [options]="etablissementType" controlName="addressSite"  [required]="true" ></app-custom-input> -->
          <mat-label
            >Adresse du domicile <span class="required">*</span></mat-label
          >
          <input
            type="text"
            class="w-100"
            formControlName="address"
            (input)="autoCompleteOnChange($event.target)"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of addressList; track option) {
            <mat-option
              [value]="getAdresseFormated(option)"
              (onSelectionChange)="addressSelected(option)"
              >{{ getAdresseFormated(option) }}</mat-option
            >
            }
          </mat-autocomplete>
          <div
            class="required"
            *ngIf="
              form.get('adress')?.touched &&
              (form?.get('adress')?.errors || form?.get('postalcode')?.errors)
            "
          >
            Veuillez saisir une addresse valide de la liste (En France)
          </div>
        </div>
        <div class="row my-3">
          <div class="col-6 d-flex flex-column">
            <mat-label>Pays <span class="required">*</span></mat-label>
            <input type="text" [formControlName]="'pays'" />
          </div>
          <div class="col-6">
            <mat-label>Code postal <span class="required">*</span></mat-label>
            <input type="text" [formControlName]="'postalcode'" class="w-100" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-6 d-flex flex-column">
            <mat-label>Ville <span class="required">*</span></mat-label>
            <input type="text" [formControlName]="'ville'" />
          </div>
          <div class="col-6">
            <mat-label>Département <span class="required">*</span></mat-label>
            <input
              type="text"
              [formControlName]="'departmentName'"
              class="w-100"
            />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12">
            <mat-label>Note</mat-label>
            <input type="text" [formControlName]="'note'" class="w-100" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-button
    color="primary"
    [disabled]="form.invalid"
    text="Suivant"
    (handleClick)="onSubmit.emit()"
    class="mx-auto text-center"
    [innerClass]="'p-3 w-100'"
  ></app-button>
  <h5 class="title-text-muted text-muted fs-16 mt-px-16">
    Vous pourrez toujours mettre à jour ces information ultérieurement
  </h5>
</div>
